module.exports = __webpack_public_path__ + "static/media/Icon_8ECEE0.3c53eeaf.png";